export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#1C1E27",
    primary:"#854CE6",
    text_primary:"#F2F3F4",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#191924',
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg: "#FFFFFF",           // White
    bgLight: "#F8F9FA",      // Very Light Gray
    primary: "#1976D2",      // Medium Blue
    text_primary: "#212121", // Very Dark Gray (almost black)
    text_secondary: "#616161", // Medium Gray
    card: "#FFFFFF",         // White
    card_light: "#F5F5F5",   // Light Gray
    button: "#1976D2",       // Medium Blue
    white: "#FFFFFF",        // White
    black: "#000000",        // Black
}
